





































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IOffer } from '../../data/model';
import Offer from '../../components/store/offer.vue';
import ProgressBar from '../../components/progress-bar.vue';
import Modal from '../../components/modal.vue';
import {
    QBtn,
    QCheckbox,
} from 'quasar';

import { Card, handleCardPayment } from 'vue-stripe-elements-plus';
import { TranslatedComponent } from '../translatedComponent';

interface StipeStatusChanged {
    brand?: string;
    complete: boolean;
    empty: boolean;
    error?: { code: string, message: string, type: string };
}

@Component({ components: { Offer, Card, ProgressBar, Modal, QBtn, QCheckbox } })
export default class Buy extends TranslatedComponent {
    @Prop()
    public offer!: IOffer;

    private cardStatus: StipeStatusChanged = { complete: false, empty: true };
    private paymentStatus: StipeStatusChanged = { complete: false, empty: true };

    private clientsecret = '';
    private registration = {
        name: '',
        surname: '',
        is_company: false,
    };
    private inProgress = false;
    private error = true;

    private stripeOptions: any = {        style: {
            base: {
                'iconColor': '#c4f0ff',
                'color': '#000',
                'fontWeight': 500,
                'fontFamily': 'Open Sans, Segoe UI, sans-serif',
                'fontSize': '16px',
                'fontSmoothing': 'antialiased',

                ':-webkit-autofill': {
                    color: '#fce883',
                },
                '::placeholder': {
                    color: '#ccccc',
                },
            },
        },
    };
    private paymentStatusChanged(data: StipeStatusChanged) {
        this.cardStatus = data;
    }

    private async pay() {
        // createToken returns a Promise which resolves in a result object with
        // either a token or an error key.
        // See https://stripe.com/docs/api#tokens for the token object.
        // See https://stripe.com/docs/api#errors for the error object.
        // More general https://stripe.com/docs/stripe.js#stripe-create-token.
        this.inProgress = true;
        console.log(handleCardPayment);
        try {
            const data = await handleCardPayment(this.clientsecret);
            if (data.error) {
                this.error = true;
                console.log('error');
            }
            console.log(data);
            this.inProgress = false;
        } catch (exception) {
            this.error = true;
            this.inProgress = false;
        }

    }
}
